// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.productSlider = function () {
  /**
   * @var {number}
   * Time in milliseconds after which we remove the lazy loading on our sldier images
   */
  const LAZY_LOAD_DELAY_MS = 2000;

  /**
   * @param {HTMLElement | null}
   * The slider element itself
   */
  const slider = document.querySelector("[data-js-product-slider]");

  /**
   * @param {HTMLElement[]}
   * A container to display the active slide number
   */
  const dots = document.querySelectorAll("[data-js-product-slider-dot]");

  /**
   * @param {Record<string, string>}
   * names of CSS classes for styling hooks
   */
  const classes = {
    active: "is-active",
  };

  /**
   * @param {HTMLButtonElement[]}
   * Next/previous buttons
   */
  const buttons = document.querySelectorAll("[data-js-product-slider-nav]");

  /**
   * Determine what to do if the user clicks a next/previous nav button
   * @param {Event} event
   *
   * @return {void}
   */
  const handleButtonClick = (event) => {
    if (!slider) {
      return;
    }

    const sliderPosition = slider?.scrollLeft || 0;
    const slideWidth = Math.round(
      slider?.scrollWidth / slider?.childElementCount
    );
    const children = slider?.childElementCount;
    const direction = event.currentTarget?.getAttribute(
      "data-js-product-slider-nav"
    );

    /** Webkit/Blink miscalculate the width by 1-2px so if we make this 5 we should be safe */
    const ACCOUNT_FOR_WEBKIT_OFFSET = 5;

    /* We are looking at the first slide */
    const isFirst = slideWidth > sliderPosition;

    /* We are looking at the last slide */
    const isLast =
      sliderPosition + ACCOUNT_FOR_WEBKIT_OFFSET > slideWidth * (children - 1);

    /** The new place where we want to send the slider */
    let newLeft = 0;

    if (direction == "previous") {
      if (isFirst) {
        newLeft = slideWidth * (children - 1);
      } else {
        newLeft = sliderPosition - slideWidth;
      }
    } else {
      if (!isLast) {
        newLeft = sliderPosition + slideWidth;
      }
    }

    slider.scrollLeft = newLeft;
  };

  /**
   * We lazy load images that are off screen but the client doesn't like that the images then load on scroll
   * so we undo the lazy loading of them after a small delay
   *
   * @return {void}
   */
  const unLazyLoadImages = () => {
    setTimeout(() => {
      const images = slider?.querySelectorAll('[loading="lazy"]');
      images?.forEach((image) => image.removeAttribute("loading"));
    }, LAZY_LOAD_DELAY_MS);
  };

  /**
   * When the user scrolls the slider
   * work out where it has scrolled to and then update its controls accordingly
   *
   * @return {void}
   */
  const handleScroll = () => {
    if (!slider || !dots || dots.length === 0) {
      return;
    }

    const sliderPosition = slider.scrollLeft;
    const slideWidth = Math.round(
      slider.scrollWidth / slider.childElementCount
    );

    for (let i = 0; i < dots.length; i++) {
      dots[i].classList.remove(classes.active);
    }

    if (sliderPosition < slideWidth) {
      dots[0].classList.add(classes.active);
    } else {
      // Calculate which slide we're currently viewing
      const activeSlideIndex = Math.round(sliderPosition / slideWidth);

      // Remove active from all dots
      for (let i = 0; i < dots.length; i++) {
        dots[i].classList.remove(classes.active);
      }

      // Add active to only the current dot
      if (dots[activeSlideIndex]) {
        dots[activeSlideIndex].classList.add(classes.active);
      }
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    for (let i = 0; i < buttons.length; i++) {
      buttons[i].removeEventListener("click", handleButtonClick);
      buttons[i].addEventListener("click", handleButtonClick);
    }

    slider?.addEventListener("scroll", handleScroll);
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    if (!slider || !buttons) {
      return;
    }

    handleScroll();

    unLazyLoadImages();

    // Only run this is the CSS support exists
    if (CSS.supports("scroll-snap-align: start")) {
      addEventListeners();
    }
  };

  return {
    init,
  };
};

window.AndDaughter.productSlider().init();
